import React from 'react';
import CoreTextField from '@material-ui/core/TextField';
import style from 'providers/style';

const styles = style(theme => ({
  root: {
    margin: 0,
    '& p': {
      margin: 4,
    },
    '& label': {
      fontWeight: 'bolder',
      fontSize: '13px',
      textAlign: 'left'
    },
    boxShadow: '0 0 25px -8px rgba(0, 0, 0, .1)',
  },
  '@media screen and (max-width: 768px)': {
    root: {
      fontSize: '.7em',
      fontWeight: 'bolder',
      '& input': {
        fontSize: '.7em'
      },
      '& label': {
        fontSize: '1em'
      }
    }
  }
}));
/**
 * @description Input
 * @see https://material-ui.com/api/input/
 */
function Input({ classes, className, ...props }) {
  return (
    <CoreTextField className={[classes.root, className].join(' ')} {...props} />
  );
}

export default styles(Input);
